import { render, staticRenderFns } from "./FormSeliteMuokkaukselle.vue?vue&type=template&id=23d3a45f&scoped=true&"
import script from "./FormSeliteMuokkaukselle.vue?vue&type=script&lang=js&"
export * from "./FormSeliteMuokkaukselle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d3a45f",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VForm,VRow,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23d3a45f')) {
      api.createRecord('23d3a45f', component.options)
    } else {
      api.reload('23d3a45f', component.options)
    }
    module.hot.accept("./FormSeliteMuokkaukselle.vue?vue&type=template&id=23d3a45f&scoped=true&", function () {
      api.rerender('23d3a45f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormSeliteMuokkaukselle.vue"
export default component.exports